import { render, staticRenderFns } from "./doctor_detail.vue?vue&type=template&id=f3e65b4e&scoped=true&"
import script from "./doctor_detail.vue?vue&type=script&lang=js&"
export * from "./doctor_detail.vue?vue&type=script&lang=js&"
import style0 from "./doctor_detail.vue?vue&type=style&index=0&id=f3e65b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e65b4e",
  null
  
)

export default component.exports